/** 发票列表相关接口 */
import request from '@/utils/util.request';

/*
 *  (invoices) 发票记录，加载数据
 */
export const invoices_load_data = (data) => {
	return request({
		url: '/invoices/loaddata',
		data,
	});
};


